export class DiaryFormElementVisibilityCondition {
  id: string;
  elementId: string;
  sourceElementId: string;
  sourceOptionId: string;

  constructor(init?: Partial<DiaryFormElementVisibilityCondition>) {
    Object.assign(this, init);
  }
}
